import { Typography } from "components";

const Footer = () => (
  <footer style={{ textAlign: "center" }}>
    <Typography size={-1} color="#757575">
      mWell Web ©2022
    </Typography>
  </footer>
);

export default Footer;
